export const validationPatterns = {
    email: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    tel: /^(\+)?(0|27)([5-9])([0-9])( )?([0-9]{3})( )?([0-9]{4})$/,
    year: /^\d{4}$/,
  }; 